import React, { useEffect, useState } from 'react';
import { Col, Row, Layout, Button } from 'antd';
import { useLocation } from 'react-router-dom';
import { Menu as MenuIcon } from 'lucide-react';
import NotificationDropdown from '../Common/notificationDropdown';
import "../assets/scss/dashboard_theme.scss";

const { Header } = Layout;

const HeaderLayout = ({ darkMode, handleToggleMode, onToggleDrawer }) => {
  const location = useLocation();
  const isSubscriptionsPage = location.pathname === "/payment/subscriptions-plans";
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const session = JSON.parse(localStorage.getItem('admin_session') || '{}');
    if (session?.session?.user) {
      // const user = session.session.user;
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Header id="antHeaderMain" className="custom-header" style={{ left: '280px', right: 0, width: 'auto', transition: 'left 0.2s' }}>
      <Row justify="space-between" align="middle" style={{ width: '100%' }}>
        <Col>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            {isMobile && (
              <Button
                type="text"
                icon={<MenuIcon size={20} />}
                onClick={onToggleDrawer}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0,
                  width: '32px',
                  height: '32px',
                  color: '#171717',
                }}
              />
            )}

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <span style={{ fontSize: '10px', fontWeight: '900', color: '#a8a29e', textTransform: 'uppercase', letterSpacing: '0.1em', lineHeight: '1.2', marginBottom: '2px' }}>
                {isSubscriptionsPage ? "Bureau Governance" : "TellBrandz System"}
              </span>
              <h2 style={{ fontSize: '14px', fontWeight: '900', margin: 0, textTransform: 'uppercase', fontStyle: 'italic', letterSpacing: '-0.05em', color: '#171717', lineHeight: '1.2' }}>
                {isSubscriptionsPage ? "Sub Tier Config" : "Master Control Panel"}
              </h2>
            </div>
          </div>
        </Col>

        <Col>
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <NotificationDropdown />
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22c55e', boxShadow: '0 0 8px #22c55e' }}></div>
              <span className="header-status-text" style={{ fontSize: '10px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
                {isSubscriptionsPage ? "Ecosystem Monitor Active" : "Engine Active"}
              </span>
            </div>
          </div>
        </Col>
      </Row>
    </Header>
  );
};

export default HeaderLayout;
